export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11864.91a8536d.jpg";